import './App.css';
import MyHome from './Home';
import { Routes, Route, BrowserRouter } from "react-router-dom";
import OldOutlet from './Old';
import NewOutlet from './New';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MyHome />} />
          <Route path="/Old" element={<OldOutlet />} />
          <Route path="/New" element={<NewOutlet />} />

        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default App;
